import classNames from 'classnames';
import type { FunctionComponent } from 'react';
import type { WithTestId } from '../../lib/utils/testid';
import type { EmbeddedType } from '../../types/embedded';
import styles from './embedded.module.scss';

/**
 * Displays an iframe.
 */
export const Embedded: FunctionComponent<EmbeddedProps> = ({
  title,
  src,
  width,
  aspectRatio,
  allow,
  'data-testid': testId
}) => {
  return <figure className={classNames(styles.wrapper, aspectRatio && styles[`ratio-${aspectRatio.replace(':', '_')}`])} role='video' data-testid={testId} style={{
    width
  }} data-sentry-component="Embedded" data-sentry-source-file="Embedded.tsx">
            <iframe className={styles.iframe} title={title} allow={allow} data-testid={testId} allowFullScreen frameBorder={0} src={src.replace('youtube.com', 'youtube-nocookie.com')} />
        </figure>;
};
export type EmbeddedProps = WithTestId<EmbeddedType>;